const $backTopBtn = $('#back-top');

$backTopBtn.click(() => {
    $('html,body').animate({scrollTop: 0}, 'slow');
});

const toggleBackTop = () => {
    if ($(window).scrollTop() === 0) {
        $backTopBtn.fadeOut().addClass('d-none').removeClass('d-flex');
    } else {
        $backTopBtn.fadeIn().removeClass('d-none').addClass('d-flex');
    }
};

$(window).scroll(toggleBackTop);

toggleBackTop();
